import { render, staticRenderFns } from "./tickets.vue?vue&type=template&id=37c28352&"
import script from "./tickets.vue?vue&type=script&lang=ts&"
export * from "./tickets.vue?vue&type=script&lang=ts&"
import style0 from "./tickets.vue?vue&type=style&index=0&id=37c28352&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports